import { env } from "./utils/enviroment"

export const IS_PROD_ENV = window.location.origin === "https://mp.membersolutions.com"

export const MP_VERSION = env.get('VITE_VERSION', 'qa0.0.0')
export const MP_VERSION_API = env.get('VITE_VERSION_API', 'v1')

export const ANALYTICS_ID = env.get('VITE_ANALYTICS_ID')

export const MP_AUTH = `${env.get('VITE_AUTH')}/api/${MP_VERSION_API}`
export const MP_USER = `${env.get('VITE_AUTH')}/api/${MP_VERSION_API}`
export const MP_MEMBER = `${env.get('VITE_MEMBER_URL')}/api/${MP_VERSION_API}`
export const MP_CLIENT = `${env.get('VITE_CLIENT_URL')}/api/${MP_VERSION_API}`
export const MP_BILLING = `${env.get('VITE_BILLING_URL')}/api/${MP_VERSION_API}`

export const RECAPTCHA_SITE_KEY = env.get('VITE_RECAPTCHA')

export const apiKey = env.get('VITE_SCHEDULE_KEY')
export const MP_SCHEDULE = env.get('VITE_SCHEDULE_URL')
